export const routes = {
    HOME: '/home',
    NOROUTE: '/',
    DASHBOARD: '/dashboard',
    OILFILTER: '/oilFilter',
    AIRFILTER: '/airFilter',
    FUELFILTER: '/fuelFilter',
    PACKAGINGSOLUTIONS: '/packagingSolutions',
    CATALOG: '/catalog',
    QUALITY: '/quality',
    ABOUTUS: '/aboutUs',
    GPADMIN: '/gp_admin',
    FILTERLOOKUP: '/filter-lookup',
    BRANDTYPE: '/gp_admin/brandType',
    IMPORT: '/gp_admin/import',
    CONTACT: '/contact',
    ADD_PRODUCTS: '/gp_admin/products',
    EDIT_PRODUCTS: '/gp_admin/edit-products',
    BLOGS: '/blogs',
    BLOG1: '/blog1',
    // RESETPASS : '/reset-password',
    ADD_USERS: '/gp_admin/add-users',
    MANAGE_USERS: '/gp_admin/manage-users',
    UPC_CBM: '/gp_admin/upc-cbm',
    SCAN: '/gp_admin/scan',
    INWARD_SCAN:'/gp_admin/inward-scan',
    UPDATE_INWARD_SCAN: '/gp_admin/updated-inward-scan',
    OUTWARD_SCAN:'/gp_admin/scan',
    CONTAINER_DETAILS: '/gp_admin/container-details',
    CONTAINER_PARTS: '/gp_admin/container-parts',
    SHIP_TO_LOC: '/gp_admin/ship-to-loc',
}
